// Top To Button

let mybutton = document.getElementById("myBtn");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// Removing .00 From Product Price

$(document).ready(function(){
  // Loop through each element with class price-item--regular
  $(".price-item--regular").each(function(){
    // Get the text content of the current element
    var priceText = $(this).text();
  
    // Remove .00
    var newPriceText = priceText.replace(".00", "");
  
    // Update the text content of the current element
    $(this).text(newPriceText);
  });
});

// Accordion

jQuery(document).ready(function () {
    jQuery('.accordians-cards').hide();

    jQuery('.accordians-btns').click(function () {
        var accordion = jQuery(this).closest('.accordians-main');
        var isAccordionVisible = accordion.find('.accordians-cards').is(':visible');
        jQuery('.accordians-cards').slideUp();
        jQuery('.accordians-btns').removeClass('active');
        jQuery('.toggle-icon').removeClass('fa-minus').addClass('fa-plus');
        if (!isAccordionVisible) {
            accordion.find('.accordians-cards').slideDown();
            jQuery(this).addClass('active');
            jQuery(this).find('.toggle-icon').removeClass('fa-plus').addClass('fa-minus');
        }
    });
});

// Responsive Menu

jQuery(document).ready(function($) {
  // Click event for opening/closing the responsive menu
  // $('.open-menu').click(function(){
  //   $('.responsive-menu').toggleClass('active');
  //   // $(this).find('i').toggleClass('fas fa-bars far fa-times');
  // });

$(document).click(function(event) {
    var sidebar = $('.responsive-menu.active');
  
    var openMenuButton = $('.open-menu');

    // Check if the clicked element is not within the sidebar or the open-menu button
    if (!sidebar.is(event.target) && sidebar.has(event.target).length === 0 &&
        !openMenuButton.is(event.target) && openMenuButton.has(event.target).length === 0) {
        sidebar.removeClass('active');
      
    }
   if ($(".responsive-menu").hasClass("active")) {
    var menuToggle = document.getElementById('text-change-toggle');
    var isOpen = false;   
    isOpen = !isOpen;
    menuToggle.innerHTML = isOpen ? 'Close' : 'Menu';
    }else{
    var hamClose = document.querySelector('.ham-close a');
    var openMenu = document.querySelector('.open-menu a');
     openMenu.innerHTML = 'Menu';
     $('li.main_opt').removeClass('main_coll');
    }
});

$('.open-menu').click(function(event){
    event.stopPropagation(); // Prevent the click event from bubbling up to the document
    $('.responsive-menu').toggleClass('active');
});


  $('.ham-close a').click(function(){
    $('.responsive-menu').removeClass('active');
    // $(this).find('i').toggleClass('fas fa-bars far fa-times');
  });

  // Click event for handling submenu items
  $('.menu-item').click(function(e) {
    var $submenu = $(this).find('.submenu');

    // Check if the clicked element is the icon
    if ($(e.target).is('i')) {
      e.preventDefault(); // Prevent default action for icon click
      // Toggle the submenu
      $submenu.slideToggle();
      // Toggle the active class to change the chevron icon
      $(this).toggleClass('active');
      // Close other submenus
      $('.submenu').not($submenu).slideUp();
      $('.menu-item').not($(this)).removeClass('active');
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
    var menuToggle = document.getElementById('text-change-toggle');
    var isOpen = false;

    menuToggle.addEventListener('click', function(event) {
        event.preventDefault();
        isOpen = !isOpen;
       // menuToggle.innerHTML = isOpen ? 'Close' : 'Menu<i class="fal fa-chevron-down"></i>';
    });
});

document.addEventListener('DOMContentLoaded', function() {
  var hamClose = document.querySelector('.ham-close a');
  var openMenu = document.querySelector('.open-menu a');
  
  hamClose.addEventListener('click', function(event) {
    event.preventDefault();
    openMenu.innerHTML = 'Menu<i class="fal fa-chevron-down"></i>';
  });
});

$(document).ready(function(){
  setTimeout(function() {
    $('#anotherBackdrop').modal('show');
    }, 7000);
});

$('li.main_opt').click(function(){
   var text = $(this).find('a#text-change-toggle').text();
      $(this).toggleClass("main_coll");
    if(text == 'Menu'){
        $(this).find('a#text-change-toggle').text('Close');
    }else{
        $(this).find('a#text-change-toggle').text('Menu');
    }
});